var _defs, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtomLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "#fff",
      display: "block"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M50 15A15 35 0 0 1 50 85A15 35 0 0 1 50 15",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "patha",
    d: "M0 0A15 35 0 0 1 0 70A15 35 0 0 1 0 0",
    fill: "none"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path",
    stroke: "#404040",
    strokeWidth: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(60 50 50)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path",
    stroke: "#404040",
    strokeWidth: 3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120 50 50)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path",
    stroke: "#404040",
    strokeWidth: 3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 15,
    r: 9,
    fill: "#6957cd"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0s"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#patha"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(60 50 50)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 15,
    r: 9,
    fill: "#6957cd"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.16666666666666666s"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#patha"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120 50 50)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 15,
    r: 9,
    fill: "#6957cd"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.3333333333333333s"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#patha"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomLoading);
export default __webpack_public_path__ + "static/media/atom-loading.2fcd85b643bca27675eaf376c8c3e0d9.svg";
export { ForwardRef as ReactComponent };